export const ADD_CHART = "ADD_CHART";
export const EDIT_CHART = "EDIT_CHART";
export const DELETE_CHART = "DELETE_CHART";
export const SELECT_CHART = "SELECT_CHART";
export const MOVE_CHART = "MOVE_CHART";

export const TOGGLE_EXPOSE = "TOGGLE_EXPOSE";
export const LOAD_STATE = "LOAD_STATE";

export const INIT_DATASET = "INIT_DATASET";
export const COMPLETED_DATASET = "COMPLETED_DATASET";
export const APPEND_TO_DATASET = "APPEND_TO_DATASET";
export const INSERT_DATASET = "INSERT_DATASET";
export const REMOVE_DATASET = "REMOVE_DATASET";


// WEBPACK FOOTER //
// ./src/kpi/store/constants/ActionTypes.js